<template>
    <div class="p-3">
        <h3>RL 3.12 Kegiatan Pelayanan Pembedahan</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Kegiatan Pelayanan Pembedahan" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'year',
                    label: 'Tahun',
                    field: 'year',
                    type: 'year',
                    colClass: 'col-sm-3',
                    component: 'DropDownYear'
                }
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-pembedahan',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",

                    },
                    {
                        title: "Jenis Kegiatan",
                        field: "spesialisasi",
                    },
                    {
                        title: "Khusus",
                        field: "khusus",
                        hozAlign: "center",
                    },
                    {
                        title: "Sedang",
                        field: "sedang",
                        hozAlign: "center",
                    },
                    {
                        title: "Besar",
                        field: "besar",
                        hozAlign: "center",
                    },
                    {
                        title: "Kecil",
                        field: "kecil",
                        hozAlign: "center",
                    },
                    {
                        title: "Jumlah",
                        field: "total",
                        hozAlign: "center",
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
